module.exports = __webpack_public_path__ + "static/img/service_keyanhuitu.9fc89991.png";